import React, { useState } from 'react';
import { Check, Link as LinkIcon } from 'lucide-react';

// Personal links log someone straight in, no PIN or code to type
export const coupleLoginLink = (code: string) => `${window.location.origin}/c/${code}`;
export const reviewerLoginLink = (code: string) => `${window.location.origin}/r/${code}`;

export const CopyLinkButton: React.FC<{ url: string; label?: string; className?: string }> = ({ url, label = 'Copy login link', className = '' }) => {
  const [copied, setCopied] = useState(false);
  return (
    <button
      type="button"
      onClick={async () => {
        await navigator.clipboard.writeText(url).catch(() => window.prompt('Copy this link', url));
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }}
      title={url}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-semibold bg-zinc-700/60 text-zinc-200 hover:bg-zinc-700 ${className}`}
    >
      {copied ? <Check className="w-3.5 h-3.5 text-green-400" /> : <LinkIcon className="w-3.5 h-3.5" />}
      {copied ? 'Copied' : label}
    </button>
  );
};
